import map from 'lodash/map';
import uniqBy from 'lodash/uniqBy';
import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';

const getIsMonthly = state => state.searchRequest.monthly;
const getSortBy = state => state.search.data.sortBy;
const getAllSpots = state => state.spots.data;
const getSelectedSpot = state => state.spot.selected;
const getPreviousSelectedSpot = state => state.spot.previousSelected;
const getCurrentFilters = state => state.filters;
const getCanadaEnabled = state =>
    state.user.data.experiments.web_canada.isFeatureEnabled;

export const getSpots = createSelector(
    [
        getIsMonthly,
        getSortBy,
        getAllSpots,
        getSelectedSpot,
        getPreviousSelectedSpot,
        getCurrentFilters,
        getCanadaEnabled,
    ],
    (
        isMonthly,
        storedSort,
        spots,
        selectedSpot,
        previousSelectedSpot,
        filters,
        isCanadaEnabled
    ) => {
        if (!spots.length) {
            return spots;
        }

        if (!isCanadaEnabled) {
            spots.filter(spot => spot.currency_type === 'usd');
        }

        const sortAttr = storedSort || 'distance';
        let preparedSpots = SpotUtils.filter(spots, filters, isMonthly);

        preparedSpots = SpotUtils.sortByAttribute(preparedSpots, sortAttr);

        if (selectedSpot) {
            preparedSpots = map(preparedSpots, spot => {
                spot.activeMarker = spot.spotId === selectedSpot.spotId;

                return spot;
            });
        }

        return uniqBy(preparedSpots, spot => {
            return spot.parking_spot_id;
        });
    }
);
